import { Controller } from "@hotwired/stimulus";
import { install, uninstall } from "@github/hotkey";

// Dropdown: a trigger button shows a floating panel. Dismisses on Escape (via
// @github/hotkey) and outside click, returning focus to the trigger. The panel
// is content-agnostic (links, buttons, a form). Wire the outside-click handler
// on the root:
//
//   data-action="click@window->dropdown#dismissOnClickOutside"
export default class extends Controller {
  static targets = ["trigger", "panel"];

  connect() {
    this.triggerTarget.setAttribute("aria-expanded", "false");
    this.panelTarget.hidden = true;
  }

  disconnect() {
    if (this.open) uninstall(this.triggerTarget);
  }

  toggle() {
    if (this.open) this.dismiss();
    else this.show();
  }

  show() {
    if (this.open) return;
    this.panelTarget.hidden = false;
    this.triggerTarget.setAttribute("aria-expanded", "true");
    // While open, Escape activates the trigger, which toggles the panel closed
    // and returns focus to it.
    install(this.triggerTarget, "Escape");
  }

  dismiss() {
    if (!this.open) return;
    this.panelTarget.hidden = true;
    this.triggerTarget.setAttribute("aria-expanded", "false");
    uninstall(this.triggerTarget);
  }

  dismissOnClickOutside(event) {
    if (this.open && !this.element.contains(event.target)) this.dismiss();
  }

  get open() {
    return !this.panelTarget.hidden;
  }
}
